module.exports = __webpack_public_path__ + "static/media/digital-report.89bf94ea.svg";